import { IconLock, IconLockOpen } from '@tabler/icons-react';
import { Button, Tooltip } from '@mantine/core';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useAllowedActions from '../../helpers/useAllowedActions';
import { setRequestedActionToUnlock, setSuggestSubscriptionModal } from '../../store/subscriptionSlice';

const LockableButton = ({ children, disabled, restrictionKey, ...rest }) => {
  const { domain } = useSelector((state) => state.domain);
  const { user } = useSelector((state) => state.auth);

  const isSuperAdmin = user.userRoles.some((role) => role.role === 'superAdmin');

  const allowedActions = useAllowedActions(domain);

  const restricted =
    restrictionKey &&
    allowedActions &&
    !allowedActions.has(restrictionKey) &&
    !allowedActions.has('*') &&
    !isSuperAdmin;

  const [hoverLock, setHoverLock] = useState(false);
  const dispatch = useDispatch();

  const handleLockClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dispatch(setSuggestSubscriptionModal(true));
    dispatch(setRequestedActionToUnlock(restrictionKey));
  };

  return (
    <>
      {restricted && (domain.account.canManageSubscriptions || isSuperAdmin) ? (
        <Tooltip label="Unlock feature." position="top">
          <Button
            {...rest}
            disabled={disabled}
            onMouseEnter={() => setHoverLock(true)}
            onMouseLeave={() => setHoverLock(false)}
            onClick={handleLockClick}
          >
            {children} {hoverLock ? <IconLockOpen size={14} /> : <IconLock size={14} />}
          </Button>
        </Tooltip>
      ) : (
        <Button {...rest} disabled={disabled || restricted}>
          {children}
        </Button>
      )}
    </>
  );
};

export default LockableButton;
